import { request } from '@umijs/max';

export type ThemeStyle = 'light' | 'dark';

export type SysUserSetting = {
  id: number;
  user_id: number;
  theme_style: ThemeStyle;
  created_at?: string;
  updated_at?: string;
};

export type SysUserSettingUpdate = {
  theme_style?: ThemeStyle;
};

export async function getMyUserSettings(options?: { [key: string]: any }) {
  return request<SysUserSetting>('/api/sys-user-settings/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateMyUserSettings(data: SysUserSettingUpdate, options?: { [key: string]: any }) {
  return request<SysUserSetting>('/api/sys-user-settings/me', {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

